import { InjectionToken } from '@angular/core';
import { Prism } from './models/prism.model';

export const PRISM = new InjectionToken<Prism>('Prism');

